module.exports = __webpack_public_path__ + "img/zixueshe.f0ddfc3c.png";